<template>
  <section v-if="signupData" class="sign-up">
    <div v-if="signupData.heading" class="white margin-bottom-xxs heavy">{{ signupData.heading }}</div>
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="signupData.body" class="section-text small white margin-bottom-xs" v-html="signupData.body"></div>
    <CommonLink
      v-for="link in signupData.contentlinks"
      :key="link.value"
      class="secondary button expanded"
      :href="link.value"
      :tracking="link.tracking"
    >
      {{ link.text }}
    </CommonLink>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { GET_SIGNUP_DATA } from '#shared/types/getters';

const navFooter = useNavFooter();
const signupData = computed(() => navFooter[GET_SIGNUP_DATA]);
</script>

<style scoped lang="scss" brand="mcom">
@import '~/assets/scss/mixins.mcom.scss';

section.sign-up {
  @include padding-top-z;
}
.section-text {
  display: block;
}
</style>
